import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import isEmpty from 'lodash/isEmpty';

import PRACTITIONERS from 'graph/queries/practitioners';
import ChatSuggestions from './ChatSuggestions';
import CreateChat from './CreateChat';
import SelectorSearch from './SelectorSearch';
import '../messages.scss';

function NewChat({ onSelectConversation }) {
  const [newChatTherapist, setNewChatTherapist] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const { data, loading, error } = useQuery(PRACTITIONERS, {
    variables: {
      search: isEmpty(searchQuery.trim()) ? null : searchQuery.trim(),
    },
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });
  const practitioners = data?.practitioners || [];

  return (
    <div className="messages-window messages-window--new-chat flex flex-column flex-auto min-h-0">
      {!newChatTherapist && (
        <SelectorSearch value={searchQuery} onChange={handleChange} />
      )}
      {newChatTherapist ? (
        <CreateChat
          onSelectConversation={onSelectConversation}
          practitioner={newChatTherapist}
        />
      ) : (
        <ChatSuggestions
          practitioners={practitioners}
          loading={loading}
          error={error}
          searchQuery={searchQuery}
          onBeginCreation={handleBeginCreation}
        />
      )}
    </div>
  );

  function handleBeginCreation(practitioner) {
    return () => {
      setNewChatTherapist(practitioner);
    };
  }

  function handleChange({ target: { value } }) {
    setSearchQuery(value);
  }
}

NewChat.propTypes = {
  onSelectConversation: PropTypes.func.isRequired,
};

export default NewChat;
